import React from 'react';
import LinkableTitle from '../../components/linkableTitle';
import CopyableSnippet from '../../components/utils/CopyableSnippet';

const Borders = () => (
  <React.Fragment>
    <div className="page-header">
      <p>Core</p>
      <h1>Borders</h1>
    </div>
    <div className="page-content">
      <div>
        <div>
          <LinkableTitle name="borders" title="Borders" />
          <div className="border">
            <div className="padding-lg">
              <CopyableSnippet code="border" />
            </div>
          </div>
          <div className="margin-top-sm border-top">
            <div className="padding-lg">
              <CopyableSnippet code="border-top" />
            </div>
          </div>
          <div className="border-right">
            <div className="padding-lg">
              <CopyableSnippet code="border-right" />
            </div>
          </div>
          <div className="border-bottom margin-bottom-md ">
            <div className="padding-lg">
              <CopyableSnippet code="border-bottom" />
            </div>
          </div>
          <div className="border-left">
            <div className="padding-lg">
              <CopyableSnippet code="border-left" />
            </div>
          </div>
        </div>
        <div className="margin-top-lg">
          <LinkableTitle name="responsive-borders" title="Responsive Borders" />
          <p>
            For responsive borders use
            <CopyableSnippet code="border-(screen)" />
            and
            <CopyableSnippet code="border-(side)-(screen)" />
            classes.
          </p>
          <p>
            The (side) values are
            <CopyableSnippet code="top" />
            <CopyableSnippet code="right" />
            <CopyableSnippet code="bottom" />
            <CopyableSnippet code="left" />
          </p>
          <p>
            The (screen) values are
            <CopyableSnippet code="screen-xs" />
            <CopyableSnippet code="screen-sm" />
            <CopyableSnippet code="screen-md" />
            <CopyableSnippet code="screen-ml" />
            <CopyableSnippet code="screen-lg" />
          </p>
          <p>Examples:</p>
          <div className="border-screen-xs margin-bottom-md">
            <div className="padding-lg">
              <CopyableSnippet code="border-screen-xs" />
            </div>
          </div>
          <div className="border-top-screen-sm">
            <div className="padding-lg">
              <CopyableSnippet code="border-top-screen-sm" />
            </div>
          </div>
          <div className="border-right-screen-md">
            <div className="padding-lg">
              <CopyableSnippet code="border-right-screen-md" />
            </div>
          </div>
          <div className="border-bottom-screen-ml margin-bottom-md">
            <div className="padding-lg">
              <CopyableSnippet code="border-bottom-screen-ml" />
            </div>
          </div>
          <div className="border-left-screen-lg">
            <div className="padding-lg">
              <CopyableSnippet code="border-left-screen-lg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
)

export default Borders;
